module.exports = __webpack_public_path__ + "img/photography-bg.043bc8e8.jpeg";